import { useEffect, useState } from "react";
import { ChevronRight, FileUp, QrCode } from "lucide-react";
import { Modal, useBlobUrl } from "../components/common";
import { api, errMsg, idr } from "../lib/api";

export const QrisCheckout = ({ title, subtitle, fields, proofFields = {}, onClose, onDone }) => {
  const { url, failed } = useBlobUrl("/qris");
  const [file, setFile] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [intent, setIntent] = useState(null);
  const fieldsKey = JSON.stringify(fields);

  useEffect(() => {
    api.post("/payments/intent", JSON.parse(fieldsKey)).then((r) => setIntent(r.data)).catch((err) => setError(errMsg(err, "Gagal menyiapkan tagihan")));
  }, [fieldsKey]);

  const submit = async () => {
    const body = new FormData();
    Object.entries({ ...fields, ...proofFields }).forEach(([k, v]) => body.append(k, v));
    body.append("intent_id", intent.id);
    body.append("file", file);
    setBusy(true);
    setError("");
    try {
      await api.post("/payments/proof", body);
      onDone();
    } catch (err) {
      setError(errMsg(err, "Gagal mengirim bukti. Coba lagi."));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Modal onClose={onClose} testId="checkout-modal">
      <p className="eyebrow">QRIS STATIS · VERIFIKASI MANUAL</p>
      <h3>{title}</h3>
      <p className="muted">{subtitle}</p>
      {!intent && error ? (
        <div className="warn-box" data-testid="checkout-blocked">{error}</div>
      ) : <>
      <div className="qris-frame" data-testid="qris-image">
        {url ? <img src={url} alt="QRIS" /> : <div className="qris-placeholder"><QrCode size={42} /><span>{failed ? "QRIS belum diunggah admin" : "Memuat QRIS…"}</span></div>}
      </div>
      {url && <a className="text-button" href={url} download="QRIS-POJOK-CHART" target="_blank" rel="noreferrer" data-testid="qris-download-link">Buka / simpan QRIS ukuran penuh</a>}
      <div className="price-line"><span>Total pembayaran</span><b data-testid="checkout-amount">{intent ? idr(intent.amount) : "…"}</b></div>
      {intent && (
        <div className="unique-box" data-testid="checkout-unique-code">
          <span>{idr(intent.base_amount)} + kode unik <b>{intent.unique_code}</b></span>
          <small>Transfer <b>tepat</b> sesuai nominal agar admin cepat mencocokkan pembayaran Anda. Berlaku 24 jam.</small>
        </div>
      )}
      <label className="upload">
        <FileUp size={20} />
        <span>{file?.name || "Unggah bukti pembayaran (JPG/PNG/PDF)"}<input type="file" accept="image/*,application/pdf" data-testid="payment-proof-input" onChange={(e) => setFile(e.target.files?.[0] || null)} /></span>
      </label>
      {intent && error && <div className="error" data-testid="checkout-error">{error}</div>}
      <button className="primary full" disabled={!file || busy || !intent} data-testid="submit-payment-proof" onClick={submit}>{busy ? "Mengirim…" : "Kirim bukti"} <ChevronRight size={17} /></button>
      <small className="muted center">Admin akan memverifikasi dalam 1×24 jam.</small>
      </>}
    </Modal>
  );
};
